



























import Vue from "vue";
import Component from "vue-class-component";
import ModlistVue from "@/components/arma/mods/Modlist.vue";
import { AxiosRequestConfig, AxiosResponse } from "axios";
import ModpackImportDialog from "../modpacks/ModpackImportDialog.vue";
import { ModpackInterface } from "@/types";
import { PropSync } from "vue-property-decorator";

@Component({
  components: { ModlistVue, ModpackImportDialog },
})
export default class ModlistCard extends Vue {
  @PropSync("modpack")
  private modpackProp!: ModpackInterface;
  @PropSync("elevation", {
    type: Number,
    default: 0,
  })
  private cardElevation!: number;

  get modpackUrl(): string {
    return Vue.axios.defaults.baseURL + "/arma/modpacks/" + this.modpackProp.id;
  }

  public async downloadItem(url: string, label: string) {
    const options: AxiosRequestConfig = {
      responseType: "blob",
      headers: {
        accept: "text/html",
      },
    };

    const response = await this.axios.get(url, options);
    this.attachDownloadTag(response, label);
  }

  public attachDownloadTag(response: AxiosResponse, filename: string) {
    const blob: Blob = new Blob([response.data], { type: "text/html" });
    const objectUrl: string = URL.createObjectURL(blob);
    const a: HTMLAnchorElement = document.createElement(
      "a"
    ) as HTMLAnchorElement;

    a.href = objectUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);
  }

  public getTotalModSize(modCollection: ModpackInterface): string {
    const totalSizeInGB = modCollection.mods.reduce((total, mod) => {
      // Check if filesize is not null before processing
      if (mod.filesize) {
        const size = parseFloat(mod.filesize.replace(" GB", ""));
        return total + size;
      }
      return total;
    }, 0);

    return `${totalSizeInGB.toFixed(2)} GB`;
  }
}
